import { ReduxAction } from '../../constants';
const initialState = {};

const entitlementStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.entitlementStatus: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
export default entitlementStatusReducer;
